<app-nav-admin--menu></app-nav-admin--menu>

<div class="configContent">
  <h1 class="configTitle">User Inputs</h1>

  <table class="table">
    <thead>
      <tr>
        <th class="userInputNumber" scope="col">#</th>
        <th class="userInputField" scope="col">Name</th>
        <th class="userInputDescription" scope="col">Description</th>

        <th class="userInputActions" scope="col">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let userInput of userInputs; index as i">
        <td class="numberColumn">{{i + 1}}</td>
        <td class="nameColumn">{{userInput.name}}</td>
        <td class="descriptionColumn">{{userInput.descriptionText}}</td>

        <td class="actionColumn">
          <button mat-icon-button (click)="editUserInput(i)"><mat-icon>edit</mat-icon></button>
          <button mat-icon-button (click)="deleteUserInput(i)"><mat-icon>delete</mat-icon></button>
        </td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td class="addUserInput">
          <button mat-icon-button (click)="addUserInput()"><mat-icon>add</mat-icon></button>
        </td>
      </tr>
    </tbody>
  </table>
  <hr />

  <div class="mb-5">
    <button mat-raised-button class="me-2" (click)="save()" [disabled]="!dirty">Save</button>
    <button mat-raised-button (click)="discard()" [disabled]="!dirty">Discard Changes</button>
  </div>
</div>
<footer>
  <patempoFooter></patempoFooter>
</footer>
